import React, { useState } from 'react'
import { connect } from 'react-redux'
import { userFetchRequest, userUpdateRequest } from '../../../action/user-actions'
import MerchantApi from '../../../lib/api/merchantCard'
import { getBaseURL } from '../../../lib/util'

const MerchantCard = props => {
  const [card, setCard] = useState(''),
    [pin, setPin] = useState(''),
    [terms, setTerms] = useState(false),
    [redeemed, setRedeemed] = useState(false),
    [errors, setErrors] = useState([]),
    [duplicate, setDuplicate] = useState(false),
    [planId, setPlanId] = useState(null),
    [grForm, showGRForm] = useState(false),
    [firstName, setFirstName] = useState(''),
    [lastName, setLastName] = useState(''),
    [dateOfBirth, setDOB] = useState(''),
    [city, setCity] = useState(''),
    [phone, setPhone] = useState(''),
    pName = window.location.pathname,
    planName = planId && props.subscriptionPlans ? props.subscriptionPlans.find(plan => plan.id == planId).name : '',
    submitCard = () => {
      setErrors([])
      if (!terms) {
        setErrors(['Must accept terms.'])
        return
      }
      const reqPin = pName == '/claim' ? '0000' : pin
      MerchantApi.submit(card.trim(), reqPin.trim(), props.token)
        .then(res => {
          setRedeemed(true)
        })
        .catch(err => {
          console.log('err obj', err)
          setErrors([err])
        })
    }
  const getCard = () => {
      MerchantApi.get(card.trim(), props.token)
        .then(res => {
          const { user } = props
          if (!terms) {
            setErrors(['Must accept terms.'])
            return
          }
          if (user.userSubscription.find(sub => sub.subscriptionPlanId == res.subscriptionPlanId)) {
            setDuplicate(true)
          }
          if (res.subscriptionPlanId == 32) {
            showGRForm(true)
          }
          setPlanId(res.subscriptionPlanId)
          submitCard()
        })
        .catch(err => {
          setErrors([err])
        })
    },
    getUserVal = (key, user) => {
      return user[key] ? user[key] : ''
    },
    updateUser = (e) => {
      e.preventDefault()
      const { user } = props,
        { email } = user,
        userInfo = {
          firstName,
          lastName,
          dateOfBirth,
          city,
          phone,
          email,
          enabled: true
        }

      props.userUpdateRequest(userInfo)
        .then(res => {
          submitCard()
          showGRForm(false)
        })
    }

  if (!props.user || !props.user.userSubscription) {
    props.userFetchRequest()
      .then(res => {
        setFirstName(getUserVal('firstName', res))
        setLastName(getUserVal('lastName', res))
        if (res.dateOfBirth) {
          const dob = res.dateOfBirth.split('T')[0]
          setDOB(dob)
        }
        setCity(getUserVal('city', res))
        setPhone(getUserVal('phone', res))
      })
    return null
  }

  return (
    <div className='merchant-bg'>
      <div className='merchant-container center'>
        <div><p className='merchant-header'>Redeem Gift Card</p></div>
        <div className='merchant-row'>
          <div style={{ width: '30%', paddingRight: '20px' }}>
            <label className='vertical-center'
              htmlFor='merchant-card'
              style={{ display: 'block', textAlign: 'right', color: 'black' }}>Card Number</label>
          </div>
          <input className='merchant-input'
            value={card}
            onChange={(e) => { setCard(e.target.value) }}
            id='merchant-card'
            name='merchant-card'
            type='text'></input>
        </div>
        {
          pName == '/redeem' ? (
            <div className='merchant-row'>
              <div style={{ width: '30%', paddingRight: '20px' }}>
                <label className='vertical-center'
                  htmlFor='merchant-pin'
                  style={{ display: 'block', textAlign: 'right', color: 'black' }}>Pin Number</label>
              </div>
              <input className='merchant-input'
                value={pin}
                onChange={(e) => { setPin(e.target.value) }}
                id='merchant-pin'
                name='merchant-pin'
                type='text'></input>
            </div>) : null
        }
        <div className='merchant-row' style={{ height: '30px' }}>
          <input className='vertical-center'
            onChange={e => { setTerms(!terms) }}
            checked={terms}
            style={{ margin: 0, width: '20px', height: '20px', border: '2px solid black' }} type='checkbox'></input>
          <div style={{ height: '30px' }}>
            <p className='vertical-center' style={{ fontSize: '12px' }}>I have read and agree to the <a className='merchant-terms'>Terms of Use</a></p>
          </div>
        </div>
        <div>
          {errors.map(err => {
            return (<p className='merchant-error'>{err}</p>)
          })}
        </div>
        <button onClick={getCard}>Submit</button>
      </div>
      {
        redeemed ? (
          <div className='merchant-overlay' onClick={e => { e.stopPropagation() }}>
            <div className='merchant-container center'>
              <div className='center' style={{ position: 'absolute', minWidth: '350px' }}>
                <p className='merchant-header'>Congratulations!</p>
                <p style={{ textAlign: 'center' }}>You have completed your Pro Membership upgrade.</p>
                <button onClick={() => { window.location = getBaseURL() }}>Return to BaseMap</button>
              </div>
            </div>
          </div>
        ) : null
      }
      {
        duplicate ?
          (
            <div className='merchant-overlay' onClick={e => { e.stopPropagation() }}>
              <div className='merchant-container center'>
                <div className='center' style={{ position: 'absolute', minWidth: '350px' }}>
                  <p style={{ textAlign: 'center' }}>{`Your account already has a ${planName} Membership`}</p>
                  <button onClick={() => { window.location = getBaseURL() }}>Return to BaseMap</button>
                </div>
              </div>
            </div>
          ) : null
      }
      {
        grForm ? (
          <form className='global-rescue-form' onSubmit={updateUser}>
            <div className='global-rescue-header'>
              LET US KNOW
            </div>
            <div className='global-rescue-header' style={{ color: '#589900' }}>
              WHO YOU'RE PROTECTING
            </div>
            <div className="global-rescue-icon">
            </div>
            <input className='global-rescue-input'
              required='true'
              name='firstName'
              placeholder='First Name'
              value={firstName}
              onChange={(e) => { setFirstName(e.target.value) }}
              type='text'></input>
            <input className='global-rescue-input'
              required='true'
              placeholder='Last Name'
              name='lastName'
              value={lastName}
              onChange={(e) => { setLastName(e.target.value) }}
              type='text'></input>
            <input className='global-rescue-input'
              required='true'
              name='dateOfBirth'
              placeholder='MM/DD/YYYY'
              value={dateOfBirth}
              onChange={(e) => { setDOB(e.target.value) }}
              type='date'></input>
            <input className='global-rescue-input'
              placeholder='City'
              name='city'
              value={city}
              onChange={(e) => { setCity(e.target.value) }}
              type='text'></input>
            <input className='global-rescue-input'
              placeholder='Phone Numer'
              name='phone'
              value={phone}
              onChange={(e) => { setPhone(e.target.value) }}
              type='text'></input>
            <label style={{ width: '100%', textAlign: 'center', color: '#959595', display: 'flex', justifyContent: 'center' }}>
              <input type='checkbox' style={{ width: '30px' }} required='true'></input>
            By signing up you agree to our
              <a style={{ color: '#589900', marginLeft: '4px' }}
                href='https://www.basemap.com/global-rescue-terms-of-use/'
                target='_blank'>{' terms and conditions.'}</a>
            </label>
            <button>CONTINUE</button>
          </form>
        ) : null
      }
    </div>
  )
}

const mapStateToProps = state => ({
  subscriptionPlans: state.subscriptionPlans,
  token: state.auth.token,
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  userFetchRequest: () => dispatch(userFetchRequest()),
  userUpdateRequest: obj => dispatch(userUpdateRequest(obj))
})

export default connect(mapStateToProps, mapDispatchToProps)(MerchantCard)